import { Injectable } from '@angular/core';
import {
  CorporateRatingAssignmentType,
  CorporateRatingDefinitionType,
  CorporateRatingInput,
  CorporateRatingPaginateType,
  CorporateRatingType,
  CorporateUpdateRatingInput,
  CreateCorporateRatingGQL,
  DeleteCorporateRatingGQL,
  DeleteResponseDtoType,
  GetCorporateRatingsByProductGQL,
  UpdateCorporateRatingGQL,
} from '@sifca-monorepo/ecommerce-generator';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RatingService {
  // Private
  private ratingDefinition: BehaviorSubject<CorporateRatingDefinitionType[] | null> = new BehaviorSubject(null);
  private corporateRatingAssignments: BehaviorSubject<CorporateRatingAssignmentType[] | null> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(
    private getCorporateRatingsByProductGQL: GetCorporateRatingsByProductGQL,
    private createCorporateRatingGQL: CreateCorporateRatingGQL,
    private updateCorporateRatingGQL: UpdateCorporateRatingGQL,
    private deleteCorporateRatingGQL: DeleteCorporateRatingGQL,
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for ratingDefinitions
   */
  get ratingDefinitions$(): Observable<CorporateRatingDefinitionType[]> {
    return this.ratingDefinition.asObservable();
  }

  get corporateRatingAssignments$(): Observable<CorporateRatingAssignmentType[]> {
    return this.corporateRatingAssignments.asObservable();
  }

  getCorporateRatingsByProduct(productId: string): Observable<CorporateRatingPaginateType> {
    return this.getCorporateRatingsByProductGQL.fetch({ productId }).pipe(
      tap((response: any) => {
        if (response.data) {
          return response.data.getCorporateRatingsByProduct;
        }
      }),
    );
  }

  createCorporateRating(input: CorporateRatingInput): Observable<CorporateRatingType> {
    return this.createCorporateRatingGQL.mutate({ input }).pipe(
      tap((response: any) => {
        if (response.data) {
          return response.data.createCorporateRating;
        }
      }),
    );
  }

  updateCorporateRating(id: string, input: CorporateUpdateRatingInput): Observable<CorporateRatingType> {
    return this.updateCorporateRatingGQL.mutate({ id, input }).pipe(
      tap((response: any) => {
        if (response.data) {
          return response.data.updateProductRating;
        }
      }),
    );
  }

  deleteProductRating(id: string): Observable<DeleteResponseDtoType> {
    return this.deleteCorporateRatingGQL.mutate({ id }).pipe(
      tap((response: any) => {
        if (response.data) {
          return response.data.deleteProductRating;
        }
      }),
    );
  }
}
